import axios from 'axios';

const state = {
  wckits: [], // Stores the test kits
  total_page:0,
  wSearchString: "", // Stores the search query
  wPaginationPage: 1, // Stores the pagination page
  wstatus: "", // Stores the pagination page
};

const getters = {
  getWCkits: (state) => state.wckits, // Getter to access WCkits
  getWSearchString: (state) => state.wSearchString, // Getter for search string
  getWPaginationPage: (state) => state.wPaginationPage, // Getter for pagination page
  getWstatus: (state) => state.wstatus, // Getter for pagination page
};

const actions = {
  async fetchWCkits({ commit }) {
    try {
      let params = new URLSearchParams();

      if (state.wSearchString) {
        params.append("search", state.wSearchString);
      }

      if (state.wPaginationPage) {
        params.append("page", state.wPaginationPage);
      }
      if (state.wstatus) {
        params.append("status", state.wstatus);
      }

      let url = `/v1/admin/wCList?${params.toString()}`;
      const response = await axios.get(url);
  
      commit('SET_WC_KITS', response.data.data.data); // Extract `user` from API response
      commit('SET_TOTAL_PAGES', response.data.data.last_page); // Store total pages in Vuex
      return response.data.data;
    } catch (error) {
      console.error('Error fetching WC kits:', error);
    }
  },
  setWSearchString({ commit }, searchQuery) {
    commit('SET_W_SEARCH_STRING', searchQuery);
  },
  setWPaginationPage({ commit }, page) {
    commit('SET_W_PAGINATION_PAGE', page);
  },
  setWStatus({ commit }, status) {
    commit('SET_W_STATUS', status);
  },
};

const mutations = {
  SET_WC_KITS(state, kits) {
    state.wckits = kits;
  },
  SET_TOTAL_PAGES(state, kits) {
    state.total_page = kits;
  },
  SET_W_SEARCH_STRING(state, searchQuery) {
    state.wSearchString = searchQuery;
  },
  SET_W_PAGINATION_PAGE(state, page) {
    state.wPaginationPage = page;
  },
  SET_W_STATUS(state, status) {
    state.wstatus = status;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
